import { ColorTheme } from "./Theme.interface";

export const DarkColorTheme: ColorTheme = {
  primary: "#ffffff",
  tint: "#3d8cdb",
  surface: "#555555",
  onSurface: "white",
  background: "#121212",
  navigationBackground: "#222222",
};
